/*
 * should only be used for testing
 */
export const evalCode = (code) => {
  window.eval(code)
}
